export default {
  title: 'עריכת עמלות סוכנות',
  form: {
    company: 'חברה מנהלת',
    product: 'מוצר',
    agencyFeeMonthlyDeposit: 'עמלת סוכנות נפרעים מהפקדה %',
    agencyFeeMonthlyAccumulation: 'עמלת סוכנות נפרעים מצבירה %',
    agencyFeeAnnualAccumulation: 'עמלת סוכנות היקף מצבירה %',
    agencyFeeAnnualDeposit: 'עמלת סוכנות היקף מהפקדה %',
    comments: 'הערות',
  },
  notification: {
    success: {
      title: 'הפרטים עודכנו בהצלחה',
      message: 'פרטי עמלות הסוכנות עודכנו במערכת',
    },
    failure: {
      title: 'הפרטים לא עודכנו',
      message: 'אירעה שגיאה בניסיון העדכון',
    },
    validtion: {
      title: 'הפרטים לא עודכנו',
      message: 'אחד מהפרטים שהוזנו איזו תקין',
    },
  },
  side: {
    tabs: 'מידע נוסף',
    comments: 'הערות',
    histories: 'היסטוריה',
    actions: 'פעולות',
  },
};
